import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || '/api';

export default function Contacto() {
  const [info, setInfo] = useState<any>(null);
  const [form, setForm] = useState({nombre_cliente:'', telefono:'', email:'', mensaje:''});
  const [enviado, setEnviado] = useState(false);

  useEffect(() => {
    axios.get(`${API}/informacion/`).then(r => setInfo(r.data)).catch(() => {});
  }, []);

  const enviar = async (e: any) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/cotizaciones/`, form);
      setEnviado(true);
    } catch {}
  };

  return (
    <main className="min-h-screen bg-gray-50">
      <div className="bg-azul py-12 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-white/40 text-xs tracking-widest mb-2">CONTACTO</div>
          <h1 className="font-condensed text-5xl font-black text-white">Encuéntrenos</h1>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10">
        <div>
          <div className="rounded-2xl overflow-hidden mb-6 h-64 border border-gray-200">
            <iframe
              title="Ubicación TicoBaterías"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d982.4!2d-84.0654078!3d9.8810556!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8fa0e3ca94c3e3ad%3A0x1309972b2ac1ddcd!2sTicobaterias!5e0!3m2!1ses!2scr!4v1"
              width="100%"
              height="100%"
              style={{border:0}}
              allowFullScreen
              loading="lazy"
            />
          </div>
          <div className="bg-azul rounded-2xl p-6 space-y-4">
            <h3 className="font-condensed text-xl font-black text-white mb-2">
              Tico<span className="text-rojo">Baterías</span>®
            </h3>
            {[
              {icon:'📍', label:'DIRECCIÓN', val: info?.direccion || 'San José, Desamparados, San Miguel'},
              {icon:'⏰', label:'HORARIO', val: info?.horario || 'Lunes a Sábado 8am - 6pm'},
              {icon:'📞', label:'TELÉFONO', val: info?.telefono || '2270-5060'},
              {icon:'💬', label:'WHATSAPP', val: info?.whatsapp || '+506 8507-6464'},
              {icon:'✉️', label:'CORREO', val: info?.email || 'ticobaterias.ventas@gmail.com'},
            ].map(({icon, label, val}) => (
              <div key={label} className="flex gap-3">
                <div className="w-9 h-9 bg-white/10 rounded flex items-center justify-center flex-shrink-0">{icon}</div>
                <div>
                  <div className="text-rojo text-xs font-bold tracking-wider">{label}</div>
                  <div className="text-white text-sm">{val}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
          <h2 className="font-condensed text-2xl font-black text-azul mb-6">Envíenos un mensaje</h2>
          {enviado ? (
            <div className="text-center py-10">
              <div className="text-5xl mb-4">✅</div>
              <p className="text-azul font-bold">¡Mensaje enviado! Le contactaremos pronto.</p>
            </div>
          ) : (
            <form onSubmit={enviar} className="space-y-4">
              <input required placeholder="Su nombre" value={form.nombre_cliente}
                onChange={e => setForm({...form, nombre_cliente: e.target.value})}
                className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-azul"/>
              <input placeholder="Teléfono" value={form.telefono}
                onChange={e => setForm({...form, telefono: e.target.value})}
                className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-azul"/>
              <input placeholder="Email" value={form.email}
                onChange={e => setForm({...form, email: e.target.value})}
                className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-azul"/>
              <textarea required placeholder="¿En qué podemos ayudarle?" value={form.mensaje}
                onChange={e => setForm({...form, mensaje: e.target.value})}
                rows={4} className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-azul resize-none"/>
              <button type="submit" className="w-full bg-azul text-white py-3 rounded-lg font-bold hover:bg-azul-dark transition-colors">
                Enviar mensaje
              </button>
            </form>
          )}
        </div>
      </div>
    </main>
  );
}
